module.exports = __webpack_public_path__ + "static/media/Results-8.338206df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-8.jpg
// module id = 371
// module chunks = 0